export function getSocketApiBase() {
    if (process.env.REACT_APP_EPIC_SERVER_SERVICE_SERVICE_HOST) {
        return process.env.REACT_APP_EPIC_SERVER_SERVICE_SERVICE_HOST;
    }
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
        return window.location.origin;
    }
    return `http://${window.location.hostname}:5005`;
}

export function getLoginApiBase() {
    if (process.env.REACT_APP_EPIC_LOGIN_SERVICE_SERVICE_HOST) {
        return process.env.REACT_APP_EPIC_LOGIN_SERVICE_SERVICE_HOST;
    }
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
        return window.location.origin;
    }
    return `http://${window.location.hostname}:4000`;
}
